import React from "react";
import appConfig from "appConfig";
import { Alert } from "@picklebet/ui";
import type { VerificationErrorInfo } from "../../types/VerificationError";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

type VerificationErrorProps = {
  error: VerificationErrorInfo;
  /** Slot variant. `page` replaces the surrounding content; `inline` fits within it. */
  variant?: "page" | "inline";
  /** Recovery buttons rendered in the Alert action slot. */
  actions?: React.ReactNode;
  title?: string;
};

const isNonProd = appConfig.ENV !== "production";

export const VerificationError = ({
  error,
  variant = "inline",
  actions,
  title,
}: VerificationErrorProps) => {
  return (
    <Alert
      color="danger"
      title={title}
      actions={actions}
      size={variant === "page" ? "large" : "small"}
    >
      <div>
        {error.message}. If you continue to have issues, please contact{" "}
        <SupportLink openLiveChat hideChevron>
          Support
        </SupportLink>
        .
      </div>

      {isNonProd && (
        <details style={{ marginTop: 8 }}>
          <summary style={{ cursor: "pointer", opacity: 0.8 }}>
            Diagnostics
          </summary>
          <pre
            style={{
              fontSize: 11,
              marginTop: 8,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {JSON.stringify(
              {
                source: error.source,
                code: error.code,
                messageId: error.messageId,
                createdAt: error.createdAt.toISOString(),
                validationErrors: error.validationErrors,
              },
              null,
              2,
            )}
          </pre>
        </details>
      )}
    </Alert>
  );
};
